import { render, staticRenderFns } from "./set_addr.vue?vue&type=template&id=51c8e161&scoped=true"
import script from "./set_addr.vue?vue&type=script&lang=js"
export * from "./set_addr.vue?vue&type=script&lang=js"
import style0 from "./set_addr.vue?vue&type=style&index=0&id=51c8e161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8e161",
  null
  
)

export default component.exports